module.exports = __webpack_public_path__ + "static/media/ttd-logo-white.16ff6e45.svg";